// Die drei Umsatzsteuer-Formulierungen dieses Systems, an genau einer Stelle.
//
// Sie standen bis hierher in `src/worker/pdf/rechnung.ts`, das sie weiterhin re-exportiert. Sie
// liegen jetzt in `src/shared`, weil nicht nur das Dokument sie braucht: der Abrechnungs-Bildschirm
// (`src/client/routes/me/abrechnen.tsx`) zeigt dem Auftragnehmer vor dem Einreichen dieselbe
// Steuerzeile bzw. denselben Satz, den seine Rechnung danach traegt. Ein Client-Import von
// `src/worker/pdf/rechnung.ts` waere kein Weg dorthin — dieses Modul zieht pdf-lib und fontkit nach
// und gehoert nicht in ein Browser-Bundle. Eine zweite Formulierung im Client waere die Drift, gegen
// die dieses System gebaut ist: Bildschirm und PDF wuerden dann zwei Geschichten erzaehlen.
import type { VatMode } from './schemas/profil'

export const KLEINUNTERNEHMER_SENTENCE = 'Gemäß § 19 UStG wird keine Umsatzsteuer berechnet.'
export const VAT_19_LABEL = 'zzgl. 19 % USt'
export const REVERSE_CHARGE_SENTENCE = 'Steuerschuldnerschaft des Leistungsempfängers (§ 13b UStG) / Reverse charge'

/**
 * The frozen `contractor_invoices.legal_text` (spec §1.10 step 2). Part 18 writes this string at
 * submit, the renderer prints the corresponding paragraph, the Abrechnungs-Bildschirm shows it
 * before the submit — one source of truth for all three.
 */
export function vatLegalText(vatMode: VatMode): string {
  if (vatMode === 'kleinunternehmer') return KLEINUNTERNEHMER_SENTENCE
  if (vatMode === 'regelbesteuert') return VAT_19_LABEL
  return REVERSE_CHARGE_SENTENCE
}
